module.exports = __webpack_public_path__ + "BradescoSans-Italic.76590ef2ac71996a3615.woff2";


//////////////////
// WEBPACK FOOTER
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/assets/fonts/BradescoSans/BradescoSans-Italic.woff2
// module id = ../../../../../src/assets/fonts/BradescoSans/BradescoSans-Italic.woff2
// module chunks = main